import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { EstateDao } from '@app/dao/estate/estate.dao';
import { UtilsService } from '@app/providers/utils/utils.service';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EaRentFormService {
  generateSubject: Subject<UntypedFormGroup> = new Subject();

  constructor(
    protected estateDao: EstateDao,
    protected formBuilder: UntypedFormBuilder,
    protected utilsService: UtilsService,
    protected prFormService: PrFormService,
    protected notificationsService: NotificationsService,
  ) {}

  public generate(entity: any) {
    let options: AbstractControlOptions = {};

    let rents: UntypedFormGroup[] = [];
    if (entity.rents)
      for (let rent of entity.rents)
        rents.push(this.formBuilder.group(this.newModel(rent)));

    let group = this.formBuilder.group({
      rents: this.formBuilder.array(rents, Validators.nullValidator),
    });

    this.generateSubject.next(group);

    return group;
  }

  public extract(form) {
    let dto: any = {
      id: this.utilsService.emptyIsNull(form.value.id),
      isCurrent: this.utilsService.emptyIsNull(form.value.isCurrent),
      frequency: this.utilsService.emptyIsNull(form.value.frequency),
      amount: this.utilsService.emptyIsNull(form.value.amount),
      startDate: this.utilsService.emptyIsNull(form.value.startDate),
      endDate: this.utilsService.emptyIsNull(form.value.endDate),
      type: this.utilsService.emptyIsNull(form.value.type),
    };
    return dto;
  }

  public addModel(entity, form) {
    let model = {};
    if (!entity.rents) entity.rents = [];
    entity.rents.push(model);
    form.rents.push(this.formBuilder.group(this.newModel(model)));
  }

  public removeModel(index, rents, userId, estateTypeUrl, estateId) {
    let rent = rents.value[index];
    if (rent.id) {
      rent.accountId = userId;
      this.prFormService.loading();
      this.estateDao
        .deleteRealestateRent(userId, estateId, estateTypeUrl, rent.id)
        .subscribe(
          success => {
            this.prFormService.loaded();
            rents.removeAt(index);
          },
          errors => {
            console.error(errors);
            this.prFormService.loaded();
            this.notificationsService.error('La supression a échoué');
          },
        );
    } else rents.removeAt(index);
  }

  newModel(model) {
    return {
      id: [model ? model.id : null],
      amount: [model ? model.amount : null, Validators.required],
      startDate: [model ? model.startDate : null, Validators.required],
      endDate: [model ? model.endDate : null],
      frenchRate: [model ? model.frenchRate : null],
      frequency: [model ? model.frequency : null, Validators.required],
      tenant: this.formBuilder.group({
        type: [model && model.contactTenant ? model.contactTenant.type : null],
        firstName: [
          model && model.contactTenant ? model.contactTenant.firstName : null,
        ],
        lastName: [
          model && model.contactTenant ? model.contactTenant.lastName : null,
        ],
        phone: [
          model && model.contactTenant ? model.contactTenant.phone : null,
        ],
        email: [
          model && model.contactTenant ? model.contactTenant.email : null,
        ],
        amount: [
          model && model.contactTenant ? model.contactTenant.amount : null,
        ],
      }),
      monthlyAmount: [model ? model.monthlyAmount : null],
      current: [model && model.current ? model.current : true],
    };
  }
}
